const STORAGE_KEY = 'accountsEnabled';

/** Normalize gl-status / localStorage value to a boolean. */
export function normalizeAccountsEnabled(value) {
  if (typeof value === 'boolean') return value;
  if (value && typeof value === 'object' && typeof value.enabled === 'boolean') {
    return value.enabled;
  }
  if (typeof value === 'string') {
    try {
      return normalizeAccountsEnabled(JSON.parse(value));
    } catch {
      return false;
    }
  }
  return false;
}

export function getAccountsEnabledFromStorage() {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (raw == null) return null;
  return normalizeAccountsEnabled(raw);
}

export function setAccountsEnabledInStorage(value) {
  const enabled = normalizeAccountsEnabled(value);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(enabled));
  return enabled;
}

export function clearAccountsEnabledStorage() {
  localStorage.removeItem(STORAGE_KEY);
}
